import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../lib/api'
import { comicPath } from '../lib/format'
import { Icon } from './Icon'

/** Opens a random comic (never the one you're on) */
export function RandomButton({ not, className = 'btn', label = 'Random', icon = true }: { not?: string; className?: string; label?: string; icon?: boolean }) {
  const navigate = useNavigate()
  const [busy, setBusy] = useState(false)
  const go = async () => {
    setBusy(true)
    try {
      const { slug } = await api.get<{ slug: string }>(`/api/comics/random${not ? `?not=${encodeURIComponent(not)}` : ''}`)
      navigate(comicPath(slug))
    } catch {
      navigate('/')
    } finally {
      setBusy(false)
    }
  }
  return (
    <button type="button" className={className} onClick={go} disabled={busy}>
      {icon && <Icon name="shuffle" size={18} />}
      {label}
    </button>
  )
}
